export default __webpack_public_path__ + "static/media/uba-logo.a7b725e2.svg";